<!--
 * @Description: 事件详情节点标题框
 * @Author: 房旭
 * @LastEditors: 房旭
 * @Date: 2019-04-12 16:16:37
 * @LastEditTime: 2019-04-12 16:35:26
 -->
<template>
    <section class="title-content">
        <icon :custom="`iconfont ${icon}`" size="20" style="margin-right:10px;color: #fe7f45" />
        {{title}}
    </section>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        icon: {
            type: String
        }
    },
    data() {
        return {

        };
    },
    components: {},
    computed: {},
}
</script>
<style lang='less' scoped>
.title-content {
    width: 100%;
    height: 58px;
    display: flex;
    padding-left: 20px;
    background: rgb(249, 249, 249);
    justify-content: flex-start;
    align-items: center;
    font-size: 16px;
}
</style>